import React from 'react';

import PageLayout from '../../components/layout/PageLayout';
import InviteMember from '../../components/admin/InviteMember';

const InvitePage = () => {
  return (
    <PageLayout>
      <InviteMember />
    </PageLayout>
  );
};

export default InvitePage;
